// src/api/customers.api.js
import { apiFetch } from '../api.js'

// liste clients + recherche
export async function fetchCustomers(searchText = '') {
  const qs = searchText ? `?search=${encodeURIComponent(searchText)}` : ''
  return apiFetch(`/api/customers${qs}`)
}

// création client manuel
export async function createCustomerAPI(newCustomer) {
  // { name, phone, type, internal_note, email, is_active }
  return apiFetch('/api/customers', {
    method: 'POST',
    json: newCustomer,
  })
}

// ✅ update client (PUT)
export async function updateCustomerAPI(uid, patch) {
  if (!uid) throw new Error('uid manquant')

  // ⚠️ important: envoyer uniquement les champs utiles
  // (évite patch vide et évite d’écraser des champs par "")
  const payload = {}
  const keys = [
    'name',
    'phone',
    'email',
    'address',
    'type',
    'internal_note',
    'is_active',
    'loyalty_level',
    'credit_limit',
    'credit_status',
    'email_opt_out',
    'whatsapp_opt_out',
  ]
  keys.forEach((k) => {
    if (k in (patch || {})) payload[k] = patch[k]
  })

  return apiFetch(`/api/customers/${uid}`, {
    method: 'PUT',
    json: payload,
  })
}

// stats fidélité
export async function fetchFidelityStats({ from, to } = {}) {
  const params = new URLSearchParams()
  if (from) params.set('from', from)
  if (to) params.set('to', to)
  return apiFetch(`/api/customers/fidelity/stats?${params.toString()}`)
}

// liste tous les tags disponibles
export async function fetchAllTags() {
  return apiFetch('/api/customers/tags')
}

// tags d'un client
export async function fetchCustomerTags(uid) {
  return apiFetch(`/api/customers/${uid}/tags`)
}

// remplace les tags d'un client
export async function updateCustomerTags(uid, tagIds) {
  return apiFetch(`/api/customers/${uid}/tags`, {
    method: 'PUT',
    json: { tag_ids: tagIds },
  })
}

// import clients (CSV)
export async function importCustomersCSV(file) {
  const form = new FormData()
  form.append('file', file)

  return apiFetch('/api/customers/import', {
    method: 'POST',
    body: form,
    // ⚠️ pas de json / pas de Content-Type
  })
}
